(function () {

  'use strict';

  angular.module('SnmpConfigurationProvider', [])

    .factory('SnmpConfigurationsPaging', function (DEFAULT_ITEMS_PER_PAGE) {
      return function () {
        return {
          pagingCriteria: {
            page: 0,
            pageSize: DEFAULT_ITEMS_PER_PAGE,
            sort: 'NAME',
            direction: 'ASC',
            match: null,      // string
            version: null,    // string: 'V1' or 'V3'
            networkIds: null, // array of strings
            global: null,     // boolean
            embed: null
          }
        };
      };
    })

    .factory('SnmpConfigurationModel', function ($q, $http, Utils, TenantListService) {
      return function (snmpConfigurationData) {
        const SnmpConfigurationModel = {};
        const SnmpConfigurationModelPrivate = {};

        SnmpConfigurationModel.init = function (snmpConfigurationData) {
          if (Utils.objectPropertiesCheck(snmpConfigurationData, ['_links'])) {
            SnmpConfigurationModel.info = angular.copy(snmpConfigurationData);
            SnmpConfigurationModel.options = {
              isSelected: false
            };
            SnmpConfigurationModel.customProperties = {};
            SnmpConfigurationModelPrivate.normalizeLinks();
          } else {
            throw String('SnmpConfigurationModel: snmpConfigurationData is not valid');
          }
        };

        SnmpConfigurationModelPrivate.normalizeLinks = function () {
          angular.forEach(SnmpConfigurationModel.info._links, function (link, index) {
            if (angular.isObject(link) && !angular.isArray(link)) {
              const linkClean = link.href.split('?')[0];
              SnmpConfigurationModel.info._links[index].href = linkClean;
            }
          });
          const selfHrefSplit = SnmpConfigurationModel.info._links.self.href.split('/');
          SnmpConfigurationModel.customProperties.id = selfHrefSplit[selfHrefSplit.length - 1];
        };

        SnmpConfigurationModelPrivate.replaceInfo = function (embeddedKey, data, doNotReplaceEmbeddedAndLinks) {
          if (!SnmpConfigurationModel.info._embedded) {
            SnmpConfigurationModel.info._embedded = {};
          }
          if (embeddedKey) {
            SnmpConfigurationModel.info._embedded[embeddedKey] = angular.copy(data);
          } else {
            const embedded = angular.copy(SnmpConfigurationModel.info._embedded);
            const links = angular.copy(SnmpConfigurationModel.info._links);
            SnmpConfigurationModel.info = angular.copy(data);
            if (!doNotReplaceEmbeddedAndLinks) {
              SnmpConfigurationModel.info._embedded = embedded;
              SnmpConfigurationModel.info._links = links;
            }
            SnmpConfigurationModelPrivate.normalizeLinks();
          }
        };

        SnmpConfigurationModel.massDistributeSnmpConfigurationToPrinters = function (filters) {
          const url = TenantListService.currentTenant.info._links['px:printers'].href + '?type=PATCH';
          const deferred = $q.defer();
          const objectToSend = {
            filters: {
              networks: filters.Networks.length > 0 ? createListOfIds(filters.Networks) : null,
              vendors: filters.Vendors.length > 0 ? createListOfIds(filters.Vendors) : null
            },
            patch: [{
              op: 'replace',
              value: SnmpConfigurationModel.info._links.self.href,
              path: '/snmpConfiguration'
            }]
          };

          $http.post(url, objectToSend, { headers: { 'Content-Type': 'application/json-patch+json' } }).then(function (response) {
            deferred.resolve(response);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        function createListOfIds(listRaw) {
          const listOfIds = [];
          angular.forEach(listRaw, function (item) {
            listOfIds.push(item.info._links.self.href);
          });
          return listOfIds;
        }

        SnmpConfigurationModel.saveChanges = function (snmpConfigurationChanges) {
          if (snmpConfigurationChanges) {
            const patchObjectArray = Utils.getObjectsDifferencesForPatching(SnmpConfigurationModel.info, snmpConfigurationChanges.info);
            angular.forEach(patchObjectArray, function (item) {
              if (item.value === null) {
                item.op = 'remove';
                delete item.value;
              }
            });

            if (SnmpConfigurationModel.info.version !== snmpConfigurationChanges.info.version) {
              const version = {
                op: 'replace',
                path: '/version',
                value: snmpConfigurationChanges.info.version
              };
              patchObjectArray.push(version);
            }
            if (patchObjectArray.length >  0) {
              const defered = $q.defer();
              $http.patch(SnmpConfigurationModel.info._links.self.href, patchObjectArray).then(function () {
                defered.resolve();
              }).catch(function(error) {
                defered.reject(error);
              });
              return defered.promise;
            } else {
              return $q.reject();
            }
          }
        };

        SnmpConfigurationModel.deleteSnmpConfig = function (snmpConfig) {
          const deferred = $q.defer();
          const url = snmpConfig.info._links.self.href;
          $http.delete(url).then(function (response) {
            deferred.resolve(response);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        SnmpConfigurationModel.init(snmpConfigurationData);
        delete SnmpConfigurationModel.init;

        return SnmpConfigurationModel;
      };
    })

    .service('SnmpConfigurationService', function ($q, $http, TenantListService, SnmpConfigurationModel) {

      // This function retrieves all SNMP configurations and should not be used if possible.
      this.getSnmpConfigurations = function () {
        if (TenantListService.currentTenant) {
          const deferred = $q.defer();
          const url = TenantListService.currentTenant.info._links['px:snmpConfigurations'].href;
          $http.get(url).then(function (response) {
            const snmpConfigurations = [];
            if (response.data._embedded) {
              angular.forEach(response.data._embedded['px:snmpConfigurationResources'], function (snmpConfiguration) {
                snmpConfigurations.add(new SnmpConfigurationModel(snmpConfiguration));
              });
              snmpConfigurations.sort((first, second) => first.info.name.localeCompare(second.info.name));
            }
            deferred.resolve(snmpConfigurations);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        }
      };

      this.getSnmpConfigurationsPaged = function (paging) {
        if (TenantListService.currentTenant) {
          const deferred = $q.defer();
          const url = TenantListService.currentTenant.info._links['px:snmpConfigurations'].href + '/page';
          $http.post(url, paging.pagingCriteria).then(function (response) {
            deferred.resolve(response);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        }
      };

      this.getDefaultSnmpConfiguration = function () {
        if (TenantListService.currentTenant) {
          const deferred = $q.defer();
          const url = TenantListService.currentTenant.info._links['px:snmpConfigurations'].href + '/default';
          $http.get(url).then(function (response) {
            deferred.resolve(new SnmpConfigurationModel(response.data));
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        }
      };

      this.getSnmpConfigurationByUrl = function (url) {
        const deferred = $q.defer();
        $http.get(url).then(function (response) {
          deferred.resolve(new SnmpConfigurationModel(response.data));
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      };

      this.createSnmpConfiguration = function (snmpConfiguration) {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links['px:snmpConfigurations'].href;
        $http.post(url, snmpConfiguration).then(function (response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      };

      this.deleteSnmpConfigurations = function (snmpConfigurationIds) {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links['px:snmpConfigurations'].href + '/byIds';
        $http({ method: 'DELETE', url: url, data: snmpConfigurationIds }).then(function (response) {
          deferred.resolve(response.data);
        }).catch(function(error) {
          deferred.reject(error.status);
        });
        return deferred.promise;
      };

      this.extractSnmpConfigurationsFromResponse = function (response) {
        const snmpConfigurations = [];
        if (response.data._embedded) {
          angular.forEach(response.data._embedded['px:snmpConfigurationResources'], function (snmpConfiguration) {
            snmpConfigurations.add(new SnmpConfigurationModel(snmpConfiguration));
          });
        }
        return snmpConfigurations;
      };
    });
})();
